module.exports = __webpack_public_path__ + "img/pleat depth pants.625afd20.png";